import { Controller } from "@hotwired/stimulus"

// Un riquadro che si apre e si chiude (useState aperto di TestoAtti e Storico in components/readiness/AnalisiInfo.js,
// e gli elenchi da aprire della pagina Preparazione): i target `contenuto` si vedono solo aperto (React non li rendeva
// chiuso), `aperto` e `chiuso` sono le parti che si scambiano (ChevronDown/ChevronRight, o due etichette).
// Chiuso all'inizio; con `aperto` (valore) aperto all'inizio. `hidden` come attributo: vale anche per le icone SVG.
//   <div id="…" data-controller="toggle-box">
//     <button data-action="toggle-box#toggle"><svg data-toggle-box-target="aperto" hidden>…<svg data-toggle-box-target="chiuso">…</button>
//     <div data-toggle-box-target="contenuto" hidden>…</div>
//   </div>
// Morph (CONVENZIONI «Modifiche non salvate e morph»): React tiene `aperto` finché il componente resta montato, quindi
// una scheda riletta con morph che conserva il riquadro (un `id` stabile aiuta) lo lascia com'è: il valore sull'elemento
// non si riscrive (turbo:before-morph-attribute) e, finito il morph dell'elemento (turbo:morph-element, arriva dopo i
// figli), lo stato si rimette su tutti i target, anche quelli nuovi o riscritti chiusi dal server. Un riquadro tolto e
// rimesso (nuovo elemento, frame ricaricato) parte chiuso, come un componente rimontato.
export default class extends Controller {
  static targets = ["contenuto", "aperto", "chiuso"]
  static values = { aperto: Boolean }

  connect() {
    this.trattieni = (event) => {
      if (event.target === this.element && event.detail.attributeName === "data-toggle-box-aperto-value") event.preventDefault()
    }
    this.riapplica = (event) => { if (event.target === this.element) this.apertoValueChanged() }
    this.element.addEventListener("turbo:before-morph-attribute", this.trattieni)
    this.element.addEventListener("turbo:morph-element", this.riapplica)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-attribute", this.trattieni)
    this.element.removeEventListener("turbo:morph-element", this.riapplica)
  }

  // chiuso dall'utente: "toggle-box:chiuso" (chi sta dentro e in React si smontava riparte da capo, es. campo_na)
  toggle() {
    this.apertoValue = !this.apertoValue
    if (!this.apertoValue) this.dispatch("chiuso")
  }

  apertoValueChanged() {
    const aperto = this.apertoValue
    this.contenutoTargets.forEach((el) => el.toggleAttribute("hidden", !aperto))
    this.apertoTargets.forEach((el) => el.toggleAttribute("hidden", !aperto))
    this.chiusoTargets.forEach((el) => el.toggleAttribute("hidden", aperto))
  }

  // un target aggiunto da un morph (una voce nuova dello storico) prende lo stato del riquadro
  contenutoTargetConnected(el) { el.toggleAttribute("hidden", !this.apertoValue) }
  apertoTargetConnected(el) { el.toggleAttribute("hidden", !this.apertoValue) }
  chiusoTargetConnected(el) { el.toggleAttribute("hidden", this.apertoValue) }
}
